import { render, staticRenderFns } from "./BannerTable.vue?vue&type=template&id=3304cce2&scoped=true&"
import script from "./BannerTable.vue?vue&type=script&lang=js&"
export * from "./BannerTable.vue?vue&type=script&lang=js&"
import style1 from "./BannerTable.vue?vue&type=style&index=1&id=3304cce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3304cce2",
  null
  
)

export default component.exports